import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const DueDetails = (props) => {
  const {pat_id} = useParams();

  const [rows, setRows] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [dueAmount, setdueAmount] = useState({
    "due_amount":'',
    "mode":'',
    "reason":'',
  });
  const [opPaid, setOpPaid] = useState([]);
  const [labPaid, setLabPaid] = useState([]);
  const [invPaid, setInvPaid] = useState([]);
  const [minPaid, setMinPaid] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

useEffect(() => {
  async function fetchData() {
    try {
      const patResponse = await axios.get(`${baseUrl}pat-id/${pat_id}/`);
      const patData = patResponse.data;

      if (patData.length > 0) {
        const patId = patData[0].id;

        setIsLoading(true);
        const emrResponse = await axios.get(`${baseUrl}emr-view/?pat_id=${patId}&status=2`);
        const combinedData = emrResponse.data;

        setPatientData(patData);
        setCombinedData(combinedData);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  fetchData();
}, [pat_id]);

useEffect(() => {
  if (combinedData.length > 0) {
    setRows(combinedData);
  }
}, [combinedData]);

  const handleOpdueClick = (id) => {
  const filteredData = combinedData.filter(data => data.paid !== undefined && data.invoice !== undefined
    && data.fee !== undefined && data.id == id);
  setOpPaid(
    filteredData.map(data => ({
      paid: data.paid,
      balance: data.balance,
      invoice: data.invoice,
      invoice_amount: data.fee,
    }))
  );
};

const handleLabdueClick = (id) => {
  const filteredData = combinedData.filter(data => data.lab_paid !== undefined && data.lab_invoice !== undefined
    && data.lab_tot !== undefined && data.id == id);
  setLabPaid(
    filteredData.map(data => ({
      paid: data.lab_paid,
      balance: data.lab_balance,
      invoice: data.lab_invoice,
      invoice_amount: data.lab_tot,

    }))
  );
};

  const handleInvdueClick = (id) => {
  const filteredData = combinedData.filter(data => data.inv_paid !== undefined && data.inv_invoice !== undefined
    && data.inv_tot !== undefined && data.id == id);

  setInvPaid(
    filteredData.map(data => ({
      paid: data.inv_paid,
      balance: data.inv_balance,
      invoice: data.inv_invoice,
      invoice_amount: data.inv_tot,

    }))
  );
};

const handleMindueClick = (id) => {
  const filteredData = combinedData.filter(data => data.min_paid !== undefined && data.min_invoice !== undefined
    && data.min_tot !== undefined && data.id == id);

  setMinPaid(
    filteredData.map(data => ({
      paid: data.min_paid,
      balance: data.min_balance,
      invoice: data.min_invoice,
      invoice_amount: data.min_tot,

    }))
  );
};

  const handleChange = (event) => {
      setdueAmount({
        ...dueAmount,
        [event.target.name]:event.target.value
      })
 };

const handleOpSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
  const paid = document.getElementById('paid');
  const balance = document.getElementById('balance');
  const invoice = document.getElementById('invoice');
  const fee = document.getElementById('fee');

    const paidValue = paid.value;
    const balanceValue = balance.value;
    const invoiceValue = invoice.value;
    const opTotValue = fee.value;
    
    const paidDue = parseFloat(paidValue) + parseFloat(dueAmount.due_amount);
    const balanceDue = parseFloat(balanceValue) - parseFloat(dueAmount.due_amount);

    axios.post(`${baseUrl}get_due_id/`)
      .then(response => {
        const receipt = response.data.value;
        const _formData = new FormData();
        _formData.append('paid', paidDue);
        _formData.append('balance', balanceDue);
        _formData.append('invoice', invoiceValue);
        _formData.append('receipt', receipt);
        _formData.append('invoice_amount', opTotValue);
        _formData.append('paid_amount', paidDue);
        _formData.append('pat', patientData[0].id);
        _formData.append('due_amount', dueAmount.due_amount);
        _formData.append('balance', balanceDue);
        _formData.append('due_status', '1');
        _formData.append('mode', dueAmount.mode);
        _formData.append('reason', dueAmount.reason);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        axios.post(baseUrl + 'due-payment/', _formData, {
          headers: {
            'content-type': 'multiple/form-data'
          }
        })
        .then(response => {
          if (response.status == 200 || response.status == 201) {
            axios.post(baseUrl + 'update-op-payment/' + invoiceValue + '/', _formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
            .then(response => {
              Swal.fire({
                title: 'Payment Success and Invoice is Generated',
                icon: 'success',
                timer: 5000,
                showConfirmButton: false
              });
              setTimeout(() => {
                window.location.href = ('/due-details/' + pat_id);
              }, 3000);
            });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to add lab entry. Please try again later.',
            'error'
          );
        });
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to generate unique value. Please try again later.',
          'error'
        );
      });
  };
  const handleLabSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
  const paid = document.getElementById('lab_paid');
  const balance = document.getElementById('lab_balance');
  const lab_amount = document.getElementById('lab_amount');
  const lab_invoice = document.getElementById('lab_invoice');
  const lab_tot = document.getElementById('lab_tot');
  

    const paidValue = paid.value;
    const balanceValue = balance.value;
    const invAmountValue = lab_amount.value;
    const invoiceValue = lab_invoice.value;
    const invTotValue = lab_tot.value;
    

    const paidDue = parseFloat(paidValue) + parseFloat(dueAmount.due_amount);
    const balanceDue = parseFloat(balanceValue) - parseFloat(dueAmount.due_amount);

    axios.post(`${baseUrl}get_due_id/`)
      .then(response => {
        const receipt = response.data.value;
        const _formData = new FormData();
        _formData.append('lab_paid', paidDue);
        _formData.append('lab_balance', balanceDue);
        _formData.append('invoice', invoiceValue);
        _formData.append('receipt', receipt);
        _formData.append('invoice_amount', invAmountValue);
        _formData.append('paid_amount', paidDue);
        _formData.append('pat', patientData[0].id);
        _formData.append('due_amount', dueAmount.due_amount);
        _formData.append('balance', balanceDue);
        _formData.append('due_status', '1');
        _formData.append('mode', dueAmount.mode);
        _formData.append('reason', dueAmount.reason);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        axios.post(baseUrl + 'due-payment/', _formData, {
          headers: {
            'content-type': 'multiple/form-data'
          }
        })
        .then(response => {
          if (response.status == 200 || response.status == 201) {
            axios.post(baseUrl + 'update-lab-payment/' + invoiceValue + '/', _formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
            .then(response => {
              Swal.fire({
                title: 'Payment Success and Invoice is Generated',
                icon: 'success',
                timer: 5000,
                showConfirmButton: false
              });
              setTimeout(() => {
                window.location.href = ('/due-details/' + pat_id);
              }, 3000);
            });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to add lab entry. Please try again later.',
            'error'
          );
        });
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to generate unique value. Please try again later.',
          'error'
        );
      });
  };
  const handleInvSubmit = (event) => {
  event.preventDefault();
  const form = event.target;
  const paid = document.getElementById('inv_paid');
  const balance = document.getElementById('inv_balance');
  const inv_amount = document.getElementById('inv_amount');
  const inv_invoice = document.getElementById('inv_invoice');
  const inv_tot = document.getElementById('inv_tot');
  
    const paidValue = paid.value;
    const balanceValue = balance.value;
    const invAmountValue = inv_amount.value;
    const invoiceValue = inv_invoice.value;
    const invTotValue = inv_tot.value;
  

    const paidDue = parseFloat(paidValue) + parseFloat(dueAmount.due_amount);
    const balanceDue = parseFloat(balanceValue) - parseFloat(dueAmount.due_amount);

    axios.post(`${baseUrl}get_due_id/`)
      .then(response => {
        const receipt = response.data.value;
        const _formData = new FormData();
        _formData.append('inv_paid', paidDue);
        _formData.append('inv_balance', balanceDue);
        _formData.append('invoice', invoiceValue);
        _formData.append('receipt', receipt);
        _formData.append('invoice_amount', invAmountValue);
        _formData.append('paid_amount', paidValue);
        _formData.append('pat', patientData[0].id);
        _formData.append('due_amount', dueAmount.due_amount);
        _formData.append('balance', balanceDue);
        _formData.append('due_status', '1');
        _formData.append('mode', dueAmount.mode);
        _formData.append('reason', dueAmount.reason);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        axios.post(baseUrl + 'due-payment/', _formData, {
          headers: {
            'content-type': 'multiple/form-data'
          }
        })
        .then(response => {
          if (response.status == 200 || response.status == 201) {
            axios.post(baseUrl + 'update-inv-payment/' + invoiceValue + '/', _formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
            .then(response => {
              Swal.fire({
                title: 'Payment Success and Invoice is Generated',
                icon: 'success',
                timer: 5000,
                showConfirmButton: false
              });
              setTimeout(() => {
                window.location.href = ('/due-details/' + pat_id);
              }, 3000);
            });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to add lab entry. Please try again later.',
            'error'
          );
        });
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to generate unique value. Please try again later.',
          'error'
        );
      });
};

const handleMinSubmit = (event) => {
  event.preventDefault();
  const form = event.target;
  const paid = document.getElementById('min_paid');
  const balance = document.getElementById('min_balance');
  const min_amount = document.getElementById('min_amount');
  const min_invoice = document.getElementById('min_invoice');
  const min_tot = document.getElementById('min_tot');
  
    const paidValue = paid.value;
    const balanceValue = balance.value;
    const minAmountValue = min_amount.value;
    const invoiceValue = min_invoice.value;
    const minTotValue = min_tot.value;
    

    const paidDue = parseFloat(paidValue) + parseFloat(dueAmount.due_amount);
    const balanceDue = parseFloat(balanceValue) - parseFloat(dueAmount.due_amount);

    axios.post(`${baseUrl}get_due_id/`)
      .then(response => {
        const receipt = response.data.value;
        const _formData = new FormData();
        _formData.append('min_paid', paidDue);
        _formData.append('min_balance', balanceDue);
        _formData.append('invoice', invoiceValue);
        _formData.append('receipt', receipt);
        _formData.append('invoice_amount', minAmountValue);
        _formData.append('paid_amount', paidValue);
        _formData.append('pat', patientData[0].id);
        _formData.append('due_amount', dueAmount.due_amount);
        _formData.append('balance', balanceDue);
        _formData.append('due_status', '1');
        _formData.append('mode', dueAmount.mode);
        _formData.append('reason', dueAmount.reason);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        axios.post(baseUrl + 'due-payment/', _formData, {
          headers: {
            'content-type': 'multiple/form-data'
          }
        })
        .then(response => {
          if (response.status == 200 || response.status == 201) {
            axios.post(baseUrl + 'update-min-payment/' + invoiceValue + '/', _formData, {
              headers: {
                'content-type': 'multiple/form-data'
              }
            })
            .then(response => {
              Swal.fire({
                title: 'Payment Success and Invoice is Generated',
                icon: 'success',
                timer: 5000,
                showConfirmButton: false
              });
              setTimeout(() => {
                window.location.href = ('/due-details/' + pat_id);
              }, 3000);
            });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to add lab entry. Please try again later.',
            'error'
          );
        });
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to generate unique value. Please try again later.',
          'error'
        );
      });
};


  return (
  <section className="container mt-4">
   <div className="row table-responsive">
    <div className='col-md-12 col-12 mb-2'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {patientData.map((patientData, index) => (
          <tr key={index}>
            <td>{patientData.pat_id}</td>
            <td>{patientData.patient}</td>
            <td>{patientData.gender}</td>
            <td>{patientData.age}</td>
            <td>{patientData.mobile}</td>
            <td>{patientData.add_date}</td>
          </tr>
        ))}
      </tbody>
    </table>
  {!isLoading && combinedData.length > 0 ? (
        <div className="table-responsive">
              <table className="erp-table-modern">
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Appointment ID</th>
                  <th>Patient ID</th>
                  <th>Patient Name</th>
                  <th>Invoice/Receipt No</th>
                  <th>Total Amount</th>
                  <th>Paid Amount</th>
                  <th>Balance Amount</th>
                  <th>Disc Amount</th>
                  <th>Payment Mode</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                  {combinedData.map(payment => (
                    <tr key={payment.id}>
                      {(payment.balance > 0 || payment.lab_balance > 0 || payment.inv_balance > 0 || payment.min_balance > 0) && (
                        <>
                          <td>{payment.add_date_date}<br />{payment.add_time}</td>
                          <td>{payment.appt_id}</td>
                          <td>{payment.pat__pat_id}</td>
                          <td>{payment.pat__patient}</td>
                          <td>
                            <Link to={
                              payment.invoice
                                ? `/op-invoice/${payment.invoice}`
                                : payment.lab_invoice
                                ? `/lab-invoice-op/${payment.lab_invoice}`
                                : payment.inv_invoice
                                ? `/inv-invoice-op/${payment.inv_invoice}`
                                : payment.min_invoice
                                ? `/min-invoice-op/${payment.min_invoice}`
                                :''
                            }
                            target="_blank">
                              {payment.invoice || payment.lab_invoice || payment.inv_invoice || payment.min_invoice}
                            </Link>
                          </td>
                          <td>{payment.fee || payment.lab_tot || payment.inv_tot || payment.min_tot}</td>
                          <td>{payment.paid || payment.lab_paid || payment.inv_paid || payment.min_paid}</td>
                          <td>{payment.balance || payment.lab_balance || payment.inv_balance || payment.min_balance}</td>
                          <td>{payment.lab_disc || payment.inv_disc || payment.min_disc}</td>
                          <td>{payment.mode || payment.lab_pmode || payment.inv_pmode || payment.min_pmode}</td>
                         <td>
                          {((payment.balance || payment.lab_balance || payment.inv_balance || payment.min_balance) > 0) ? (
                            <>
                              {payment.balance > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#due-op-modal"
                                  onClick={() => handleOpdueClick(payment.id)}
                                >
                                  Due
                                </button>
                              )}
                              {payment.lab_balance > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#due-lab-modal"
                                  onClick={() => handleLabdueClick(payment.id)}
                                >
                                  Due
                                </button>
                              )}
                              {payment.inv_balance > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#due-inv-modal"
                                  onClick={() => handleInvdueClick(payment.id)}
                                >
                                  Due
                                </button>
                              )}
                              {payment.min_balance > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  data-bs-toggle="modal"
                                  data-bs-target="#due-min-modal"
                                  onClick={() => handleMindueClick(payment.id)}
                                >
                                  Due
                                </button>
                              )}
                            </>
                          ) : (
                            "No Due"
                          )}
                        </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
                </div>
                ) : (
                <></>
              )}
    </div>
   </div>
 <div className="modal fade" id="due-op-modal" tabIndex="-1" aria-labelledby="due-op-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="due-op-modal-label">Op Due</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
          <label className="form-label">Due Pay:</label>
          <input type="number" className="form-control" id="due_amount" name="due_amount" onChange={handleChange}
            value={dueAmount.due_amount} />
            {opPaid.map((data, index) => (
              <React.Fragment key={index}>
               <input type="hidden" className="form-control" id="invoice" name="invoice"
                value={data.invoice} />
               <input type="hidden" className="form-control" id="fee" name="fee"
                value={data.invoice_amount} />
               <label className="form-label">Paid:</label>
                <input type="text" className="form-control" id="paid" name="paid"
                value={data.paid}  disabled/>
                <label className="form-label">Due:</label>
               <input type="text" className="form-control" id="balance" name="balance"
                value={data.balance}  disabled/>
              </React.Fragment>
            ))}
            <label>Choose Payment Type: </label>
            <select name="mode" id="mode" className="form-control">
               <option value="cash">Cash</option>
               <option value="card">Card</option>
            </select>
            <label className="form-label">Reason:</label>
            <input type="text" className="form-control" id="reason" name="reason" onChange={handleChange}
             value={dueAmount.reason} required/>
            <button type="button" onClick={handleOpSubmit} className="btn btn-primary mt-4">
               Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="due-lab-modal" tabIndex="-1" aria-labelledby="due-lab-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="due-lab-modal-label">Due Lab Test</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
          <label className="form-label">Due Pay:</label>
          <input type="number" className="form-control" id="due_amount" name="due_amount" onChange={handleChange}
            value={dueAmount.due_amount} />

            {labPaid.map((data, index) => (
              <React.Fragment key={index}>
               <input type="hidden" className="form-control" id="lab_amount" name="lab_amount"
                value={data.invoice_amount} />
               <input type="hidden" className="form-control" id="lab_invoice" name="lab_invoice"
                value={data.invoice} />
               <input type="hidden" className="form-control" id="lab_tot" name="lab_tot"
                value={data.inv_tot} />
               <label className="form-label">Lab Paid:</label>
                <input type="text" className="form-control" id="lab_paid" name="lab_paid"
                value={data.paid}  disabled/>
                <label className="form-label">Lab Due:</label>
               <input type="text" className="form-control" id="lab_balance" name="lab_balance"
                value={data.balance}  disabled/>
              </React.Fragment>
            ))}
            <label>Choose Payment Type: </label>
            <select name="mode" id="mode" className="form-control">
               <option value="cash">Cash</option>
               <option value="card">Card</option>
            </select>
            <label className="form-label">Reason:</label>
            <input type="text" className="form-control" id="reason" name="reason" onChange={handleChange}
             value={dueAmount.reason} required/>
            <button type="button" onClick={handleLabSubmit} className="btn btn-primary mt-4">
               Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="due-min-modal" tabIndex="-1" aria-labelledby="due-min-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="due-min-modal-label">Due Min Test</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
          <label className="form-label">Due Pay:</label>
          <input type="number" className="form-control" id="due_amount" name="due_amount" onChange={handleChange}
            value={dueAmount.due_amount} />

            {minPaid.map((data, index) => (
              <React.Fragment key={index}>
               <input type="hidden" className="form-control" id="min_amount" name="min_amount"
                value={data.invoice_amount} />
               <input type="hidden" className="form-control" id="min_invoice" name="min_invoice"
                value={data.invoice} />
               <input type="hidden" className="form-control" id="min_tot" name="min_tot"
                value={data.min_tot} />
                <label className="form-label">Lab Paid:</label>
                <input type="text" className="form-control" id="min_paid" name="min_paid"
                value={data.paid}  disabled/>
                <label className="form-label">Lab Due:</label>
               <input type="text" className="form-control" id="min_balance" name="min_balance"
                value={data.balance}  disabled/>
              </React.Fragment>
            ))}
            <label>Choose Payment Type: </label>
            <select name="mode" id="mode" className="form-control">
               <option value="cash">Cash</option>
               <option value="card">Card</option>
            </select>
            <label className="form-label">Reason:</label>
            <input type="text" className="form-control" id="reason" name="reason" onChange={handleChange}
             value={dueAmount.reason} required/>
            <button type="button" onClick={handleMinSubmit} className="btn btn-primary mt-4">
               Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="due-inv-modal" tabIndex="-1" aria-labelledby="due-lab-modal-label"
   aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="due-lab-modal-label">due Radiology Test</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
          <label className="form-label">Due Pay:</label>
          <input type="number" className="form-control" id="due_amount" name="due_amount" onChange={handleChange}
            value={dueAmount.due_amount} />

            {invPaid.map((data, index) => (
              <React.Fragment key={index}>
               <input type="hidden" className="form-control" id="inv_amount" name="inv_amount"
                value={data.invoice_amount} />
               <input type="hidden" className="form-control" id="inv_invoice" name="inv_invoice"
                value={data.invoice} />
               <input type="hidden" className="form-control" id="inv_tot" name="inv_tot"
                value={data.inv_tot} />
               <label className="form-label">Radigy. Paid:</label>
                <input type="text" className="form-control" id="inv_paid" name="inv_paid"
                value={data.paid}  disabled/>
                <label className="form-label">Radigy. Due:</label>
               <input type="text" className="form-control" id="inv_balance" name="inv_balance"
                value={data.balance}  disabled/>
              </React.Fragment>
            ))}
            <label>Choose Payment Type: </label>
            <select name="mode" id="mode" className="form-control">
               <option value="cash">Cash</option>
               <option value="card">Card</option>
            </select>
            <label className="form-label">Reason:</label>
            <input type="text" className="form-control" id="reason" name="reason" onChange={handleChange}
             value={dueAmount.reason} required/>
            <button type="button" onClick={handleInvSubmit} className="btn btn-primary mt-4">
               Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>
</section>
  );
};

export default DueDetails;
